import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const SutraList = lazy(() => import('@/pages/sutra/List.tsx'));
const SutraDetail = lazy(() => import('@/pages/sutra/Detail'));
const SutraEdit = lazy(() => import('@/pages/sutra/Edit'));
const SutraCreate = lazy(() => import('@/pages/sutra/Create'));

export const sutraRoutes: RouteObject = {
  path: 'sutra',
  children: [
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:sutra:list">
          <SuspenseWrapper>
            <SutraList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },

    {
      path: 'detail/:sutraUuid',
      element: (
        <ProtectedRoute pageKey="page:sutra:detail">
          <SuspenseWrapper>
            <SutraDetail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },

    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:sutra:create">
          <SuspenseWrapper>
            <SutraCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:sutra:edit">
          <SuspenseWrapper>
            <SutraEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};
